export var NEWSLETTER = "newsletter";
